import { createSlice } from "@reduxjs/toolkit";
import { deleteTaluka, getTaluka, undoDeleteTaluka } from "./taluka.api";

const talukaSlice = createSlice({
  name: "taluka",
  initialState: {
    taluka: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTaluka.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getTaluka.fulfilled, (state, action) => {
      state.loading = false;
      state.taluka = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getTaluka.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteTaluka.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteTaluka.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.taluka.data) {
        state.taluka.data = state.taluka.data.filter((taluka) => {
          return taluka._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.taluka.data is not an array:", state.taluka.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteTaluka.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteTaluka.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteTaluka.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.taluka.data) {
        state.taluka.data = state.taluka.data.filter((taluka) => {
          return taluka._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.taluka.data is not an array:", state.taluka.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteTaluka.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = talukaSlice.actions;
export default talukaSlice.reducer;
